import { useEffect } from 'react';
import { TSectionsSuggestionConfig } from 'core/model/interfaces/catalogues.interface';
import { useAppDispatch, useAppSelector } from 'core/store/store.utils';
import { getSuggestedProducts } from 'core/store/suggested-products';
import { getSuggestionsForSection } from 'core/store/suggested-products/selectors';

interface IUseSuggestionsProps {
  sectionId: keyof TSectionsSuggestionConfig;
  autoLoad?: boolean;
  itemsPerPage?: number;
}
export const useSuggestions = ({ sectionId, autoLoad = true, itemsPerPage }: IUseSuggestionsProps) => {
  const dispatch = useAppDispatch();
  const isCartLoading = useAppSelector(state => state.cart.cartLoading);
  const sectionState = useAppSelector(state => getSuggestionsForSection(state, sectionId));

  const areSuggestionsLoading = sectionState?.isLoading || false;
  const suggestions = sectionState?.suggestions || [];
  const shouldSuggestionsAppearAsLoading = isCartLoading || areSuggestionsLoading;

  useEffect(() => {
    if (autoLoad) {
      dispatch(getSuggestedProducts({ sectionId, itemsPerPage }));
    }
  }, [dispatch, sectionId, autoLoad, itemsPerPage]);

  return {
    suggestions,
    areSuggestionsLoading,
    shouldSuggestionsAppearAsLoading,
  };
};
